import AsyncStorage from '@react-native-async-storage/async-storage';

export const VPN_STORAGE = async () => {
	try {
		const value = await AsyncStorage.getItem('@vpn');
		if (value !== null) {
			return value;
		}
	} catch (e) {
		// error reading value
	}
}